
(function () {
  var KEY = '#tw-farg=';
  var SEP = ' - ';
  var imageFilterSetUp = false;

  /* ===================== Hjälpare ===================== */

  function inputsFor(index) {
    var out = [];
    document.querySelectorAll('[data-index="option' + index + '"]').forEach(function (i) {
      if (i.value) out.push(i);
    });
    return out;
  }

  function norm(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function checkedValue(index) {
    var list = inputsFor(index);
    for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value;
    return null;
  }

  function wrapperFor(index, labelPattern) {
    var list = inputsFor(index);
    if (!list.length) return null;
    var wrap = list[0].closest('.variant-wrapper');
    if (!wrap) return null;
    if (labelPattern && !labelPattern.test(wrap.textContent.slice(0, 140))) return null;
    return wrap;
  }

  function findInput(index, value) {
    var list = inputsFor(index);
    var wantValue = norm(value);
    if (!wantValue) return null;
    var i;

    for (i = 0; i < list.length; i++) if (list[i].value === value) return list[i];
    for (i = 0; i < list.length; i++) if (norm(list[i].value) === wantValue) return list[i];
    for (i = 0; i < list.length; i++) {
      var v = norm(list[i].value);
      if (v.indexOf(wantValue) > -1 || wantValue.indexOf(v) > -1) return list[i];
    }
    return null;
  }

  function fullTitle() {
    var el = document.querySelector('.product-single__title');
    return el ? el.textContent.trim().replace(/\s+/g, ' ') : null;
  }

  function titleParts() {
    var full = fullTitle();
    if (!full) return null;
    var i = full.lastIndexOf(SEP);
    if (i < 1) return null;
    return { base: full.slice(0, i), color: full.slice(i + SEP.length) };
  }

  function money(cents) {
    var kr = Math.round(cents) / 100;
    var whole = Math.floor(kr);
    var rest = Math.round((kr - whole) * 100);
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (rest > 0) s += ',' + (rest < 10 ? '0' : '') + rest;
    return s + ' kr';
  }

  function ownVariant(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var title = norm(p.title);
    var best = null;
    var bestScore = -1;

    p.variants.forEach(function (v) {
      var opts = v.options || [];
      var score = 0;
      var ok = opts.length > 0;

      opts.forEach(function (o) {
        var n = norm(o);
        if (n && title.indexOf(n) > -1) score += n.length;
        else ok = false;
      });

      if (ok && score > bestScore) { bestScore = score; best = v; }
    });

    return best || p.variants[0];
  }

  /* ===================== 1. Centimeter ===================== */

  function addCm() {
    document.querySelectorAll('.tw-sizes__pill').forEach(function (pill) {
      var meta = pill.querySelector('.tw-sizes__meta');
      if (!meta || meta.getAttribute('data-tw-cm-done')) return;

      var m = (pill.getAttribute('href') || '').match(/(\d{2,3})-?cm(?:[^a-z]|$)/i);
      if (!m) return;

      var current = meta.textContent.trim();
      if (/väsk/i.test(current)) return;

      meta.textContent = m[1] + ' cm · ' + current;
      meta.setAttribute('data-tw-cm-done', '1');
    });
  }

  /* ===================== 2. Färgen följer med ===================== */

  function attachSizeLinks() {
    document.querySelectorAll('.tw-sizes__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var color = checkedValue(1);
        if (!color) return;
        var base = this.getAttribute('href');
        if (!base) return;
        this.setAttribute('href', base.split('#')[0] + KEY + encodeURIComponent(color));
      });
    });
  }

  /* ===================== 4. Dubbel storleksväljare ===================== */

  function hideThemeSizeOption() {
    if (!document.querySelector('.tw-sizes__pill')) return false;

    var hidAny = false;
    [2, 3].forEach(function (index) {
      var wrap = wrapperFor(index, /storlek|size/i);
      if (!wrap) return;
      if (inputsFor(index).length < 2) return;
      wrap.style.display = 'none';
      hidAny = true;
    });
    return hidAny;
  }

  /* ===================== 5. Rätt pris i knapparna ===================== */

  function fixPillPrices() {
    document.querySelectorAll('.tw-sizes__pill').forEach(function (pill) {
      var priceEl = pill.querySelector('.tw-sizes__price');
      var href = pill.getAttribute('href');
      if (!priceEl || !href) return;

      fetch(href.split('#')[0] + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (p) {
          if (p.price_min === p.price_max) return;
          var v = ownVariant(p);
          if (v) priceEl.textContent = money(v.price);
        })
        .catch(function () {});
    });
  }

  /* ===================== 6. Lås varianten ===================== */

  var want = null;

  function idFields() {
    return document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
  }

  function locked() {
    if (!want) return false;
    var radio = findInput(1, want.options ? want.options[0] : null);
    if (!radio || !radio.checked) return false;
    if (!want.available) return true;
    var ok = false;
    idFields().forEach(function (f) { if (String(f.value) === String(want.id)) ok = true; });
    return ok;
  }

  function applyLock(alwaysDispatch) {
    if (!want) return;

    var changed = false;
    (want.options || []).forEach(function (val, i) {
      var input = findInput(i + 1, val);
      if (input && !input.checked) { input.checked = true; changed = true; }
    });

    if (changed || alwaysDispatch) {
      var any = document.querySelector('[data-index="option1"]');
      if (any) any.dispatchEvent(new Event('change', { bubbles: true }));
    }

    idFields().forEach(function (f) {
      if (!want.available) {
        if (f.value !== '') f.value = '';
        return;
      }
      if (String(f.value) === String(want.id)) return;

      var ok = true;
      if (f.tagName === 'SELECT') {
        ok = false;
        for (var j = 0; j < f.options.length; j++) {
          if (String(f.options[j].value) === String(want.id) && !f.options[j].disabled) ok = true;
        }
      }
      if (ok) {
        f.value = want.id;
        f.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function markSoldOut() {
    if (!want || want.available) return;
    document.querySelectorAll('form[action*="/cart/add"] [name="add"]').forEach(function (btn) {
      btn.disabled = true;
      btn.classList.add('disabled');
      var span = btn.querySelector('span') || btn;
      if (!/slutsåld/i.test(span.textContent)) span.textContent = 'Slutsåld';
    });
  }

  function lockOwnVariant(onSettled) {
    fetch(location.pathname + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (p) {
        if (!p.variants || p.variants.length < 2) { onSettled(true); return; }

        want = ownVariant(p);
        applyLock(false);

        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          applyLock(tries > 2);
          markSoldOut();
          if (tries >= 8) {
            clearInterval(timer);
            applyLock(false);
            markSoldOut();
            onSettled(locked());
          }
        }, 200);
      })
      .catch(function () { onSettled(false); });
  }

  /* ===================== 3. Färgväljaren ===================== */

  function injectStyle() {
    if (document.getElementById('tw-colors-style')) return;
    var s = document.createElement('style');
    s.id = 'tw-colors-style';
    s.textContent = [
      '.tw-colors{margin:14px 0 4px}',
      '.tw-colors__head{font-size:13px;color:#2a2018;margin:0 0 8px;text-transform:none;letter-spacing:0}',
      '.tw-colors__head strong{font-weight:700}',
      '.tw-colors__head em{font-style:normal;color:#b5453a;font-weight:700}',
      '.tw-colors__row{display:flex;gap:8px;overflow-x:auto;padding:2px 2px 6px;-webkit-overflow-scrolling:touch;scrollbar-width:none}',
      '.tw-colors__row::-webkit-scrollbar{display:none}',
      '.tw-colors__item{position:relative;flex:0 0 auto;width:58px;text-decoration:none;color:#2a2018;text-align:center}',
      '.tw-colors__thumb{display:block;width:58px;height:58px;border:1.5px solid #e5e0d6;border-radius:9px;background:#f7f3ec center/cover no-repeat;box-sizing:border-box}',
      '.tw-colors__item:hover .tw-colors__thumb{border-color:#1f4d3d}',
      '.tw-colors__item.is-current .tw-colors__thumb{border-color:#1f4d3d;border-width:2.5px}',
      '.tw-colors__name{display:block;font-size:11px;line-height:1.25;margin-top:5px;text-transform:none;letter-spacing:0;white-space:normal;min-height:14px}',
      '.tw-colors__item.is-sold .tw-colors__thumb{opacity:.4;filter:grayscale(1)}',
      '.tw-colors__item.is-sold .tw-colors__name{opacity:.55}',
      '.tw-colors__flag{position:absolute;left:50%;top:29px;transform:translate(-50%,-50%);background:#2a2018;color:#fff;font-size:9px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;padding:2px 5px;border-radius:3px;white-space:nowrap;pointer-events:none}',
      '.tw-colors--loading .tw-colors__thumb{background:#efeae1;border-color:#efeae1;animation:tw-pulse 1.1s ease-in-out infinite}',
      '@keyframes tw-pulse{0%,100%{opacity:1}50%{opacity:.45}}'
    ].join('');
    document.head.appendChild(s);
  }

  function shell(color) {
    var box = document.createElement('div');
    box.className = 'tw-colors';

    var head = document.createElement('div');
    head.className = 'tw-colors__head';
    head.innerHTML = 'Färg: <strong></strong><em></em>';
    head.querySelector('strong').textContent = color;
    box.appendChild(head);

    var row = document.createElement('div');
    row.className = 'tw-colors__row';
    box.appendChild(row);
    return box;
  }

  function skeleton(color, count) {
    var box = shell(color);
    box.classList.add('tw-colors--loading');
    var row = box.querySelector('.tw-colors__row');

    for (var i = 0; i < count; i++) {
      var item = document.createElement('span');
      item.className = 'tw-colors__item';
      var thumb = document.createElement('span');
      thumb.className = 'tw-colors__thumb';
      item.appendChild(thumb);
      var name = document.createElement('span');
      name.className = 'tw-colors__name';
      item.appendChild(name);
      row.appendChild(item);
    }
    return box;
  }

  function fill(box, sibs) {
    var row = box.querySelector('.tw-colors__row');
    var here = window.location.pathname;
    row.textContent = '';

    sibs.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'tw-colors__item';
      a.href = s.u;
      a.title = s.name + (s.a ? '' : ', slutsåld');
      if (s.u === here) {
        a.classList.add('is-current');
        if (!s.a) {
          var em = box.querySelector('.tw-colors__head em');
          if (em) em.textContent = ' · slutsåld';
        }
      }
      if (!s.a) a.classList.add('is-sold');

      var thumb = document.createElement('span');
      thumb.className = 'tw-colors__thumb';
      if (s.i) thumb.style.backgroundImage = 'url("' + s.i + '")';
      a.appendChild(thumb);

      if (!s.a) {
        var flag = document.createElement('span');
        flag.className = 'tw-colors__flag';
        flag.textContent = 'Slut';
        a.appendChild(flag);
      }

      var name = document.createElement('span');
      name.className = 'tw-colors__name';
      name.textContent = s.name;
      a.appendChild(name);

      row.appendChild(a);
    });

    box.classList.remove('tw-colors--loading');
  }

  function setupColors() {
    var parts = titleParts();
    if (!parts) return;

    var wrap = wrapperFor(1, /färg|farg|color|colour/i);
    if (!wrap) return;

    var count = inputsFor(1).length;
    if (count < 2) return;

    injectStyle();

    var box = skeleton(parts.color, count);
    wrap.parentNode.insertBefore(box, wrap);
    wrap.style.display = 'none';

    function giveUp() {
      if (box.parentNode) box.parentNode.removeChild(box);
      wrap.style.display = '';
    }

    fetch('/search?view=json&type=product&q=' + encodeURIComponent(parts.base),
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (txt) {
        var data = JSON.parse(txt.trim());
        var seen = {};
        var sibs = [];

        data.forEach(function (d) {
          if (!d.t || d.t.indexOf(parts.base + SEP) !== 0) return;
          var path = d.u.split('?')[0];
          if (seen[path]) return;
          seen[path] = 1;
          sibs.push({
            name: d.t.slice(parts.base.length + SEP.length),
            u: path,
            i: d.i,
            a: d.a !== false
          });
        });

        if (sibs.length < 2) { giveUp(); return; }

        sibs.sort(function (a, b) { return a.name.localeCompare(b.name, 'sv'); });
        fill(box, sibs);
      })
      .catch(giveUp);

    lockOwnVariant(function (ok) {
      if (!ok) wrap.style.display = '';
      initImageFilter();
    });
  }

  /* ===================== 7. Bildfilter per färg ===================== */

  function initImageFilter() {
    if (imageFilterSetUp) return;
    imageFilterSetUp = true;

    var flktyEl = document.querySelector('.product-slideshow');
    if (!flktyEl) return;
    var flkty = Flickity.data(flktyEl);
    if (!flkty) return;

    fetch(location.pathname + '.json')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        var images = data.product.images;
        var variants = data.product.variants;
        if (!images || images.length < 2) return;

        var vidToColor = {};
        variants.forEach(function (v) { vidToColor[v.id] = v.option1; });

        var colorToSlides = {};
        var curColor = null;
        images.forEach(function (img, i) {
          if (img.variant_ids && img.variant_ids.length > 0) {
            curColor = vidToColor[img.variant_ids[0]] || null;
          }
          if (!curColor) return;
          if (!colorToSlides[curColor]) colorToSlides[curColor] = [];
          colorToSlides[curColor].push(i);
        });

        if (Object.keys(colorToSlides).length < 2) return;

        var activeColor = null;

        function applyFilter(color) {
          if (activeColor === color) return;
          activeColor = color;
          var range = colorToSlides[color];
          if (!range) return;

          if (range.indexOf(flkty.selectedIndex) < 0) {
            flkty.select(range[0], false, true);
          }

          document.querySelectorAll('.product__thumb-item').forEach(function (t) {
            var idx = parseInt(t.dataset.index, 10);
            t.style.display = range.indexOf(idx) >= 0 ? '' : 'none';
          });

          document.dispatchEvent(new CustomEvent('tw:colorfilter', { detail: { color: color, slides: range } }));
        }

        flkty.on('change', function (index) {
          if (!activeColor) return;
          var range = colorToSlides[activeColor];
          if (!range) return;
          if (index < range[0]) { flkty.select(range[0]); return; }
          if (index > range[range.length - 1]) { flkty.select(range[range.length - 1]); return; }
        });

        document.addEventListener('variant:change', function (evt) {
          var v = evt.detail && evt.detail.variant;
          if (v && colorToSlides[v.option1]) applyFilter(v.option1);
        });

        var color = checkedValue(1);
        if (!color || !colorToSlides[color]) {
          var parts = titleParts();
          if (parts) color = parts.color;
        }
        if (!color || !colorToSlides[color]) {
          color = Object.keys(colorToSlides)[0];
        }
        if (color && colorToSlides[color]) applyFilter(color);
      })
      .catch(function () {});
  }

  /* ===================== Start ===================== */

  function init() {
    addCm();
    attachSizeLinks();
    if (hideThemeSizeOption()) fixPillPrices();
    setupColors();

    setTimeout(initImageFilter, 1800);
    if (!titleParts()) {
      var input = document.querySelector('[data-index="option1"] input[type="radio"]:checked')
                 || document.querySelector('[data-index="option1"] input[type="radio"]');
      if (input) setTimeout(function () {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 80);
    }
  }

  if (document.querySelector('[data-index="option1"]')) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
